import './index.scss';
import React from 'react';
import { List, TextareaItem } from 'antd-mobile';

/** 课堂评价组件 */
function ClassroomEvaluation(props) {
  return (
    <div className="classroom-evaluation">
      <div className="classroom-evaluation-content">
        <List>
          <TextareaItem
            disabled={props.disabled}
            value={props.value}
            maxLength={250}
            rows={7}
            placeholder="输入内容..."
            onChange={props.onChange}
          />
        </List>
      </div>
    </div>
  );
}

export default ClassroomEvaluation;
